// /**
//  * Zones - Add
//  */

// React
import React, {useEffect, useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {
  TextField,
  Grid,
  Button,
  CardHeader,
  CardContent,
  Card,
  Typography,
  CircularProgress,
  DialogTitle,
  Dialog,
  DialogActions,
  IconButton,
  Paper,
  Divider,
} from '@material-ui/core';

import classes from './add.module.scss';
import AddMobile from '../mobileView/components/Add';

// helpers
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';
import useQuery from '../../../utils/hook/useQuery';
import windowSize from '../../../utils/hook/useWindowResize';

// Type
import {addProvider, Payload, PayloadCreate, State} from '../interfaces';

// Redux
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../redux/reducers';
import {
  makeSelectProvidersList,
  makeSelectCountList,
  makeSelectError,
  makeSelectLoading,
} from '.././selectors';

import {createProviderAction, getProvidersAction} from '.././actions';
import RonadIcons from '../../../components/iconComponent';

type Props = {
  createProvider: (body: addProvider) => void;
  count: number;
  error: any;
  onClose: () => void;
};

type Inputs = {
  name: string;
  code: string;
};

function Add(props: Props) {
  const {register, handleSubmit, watch, errors} = useForm<Inputs>();
  const [formData, setFormData] = useState(null as null | addProvider);
  const [checkAddProvider, setCheckAddProvider] = useState(false as boolean);
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,

    size: 10,
  });
  const [isMob, setIsMob] = useState(false);
  const {width} = windowSize();

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const handleCloseCheck = () => {
    setCheckAddProvider(false);
    setFormData(null);
  };

  const onSubmit = ({name, code}: Inputs) => {
    handleCreateProvider({
      name,
      code,
    });
  };

  const handleSubmitAddProvider = () => {
    const callback = () => {
      setCheckAddProvider(false);
      setFormData(null);
    };
    const {name, code}: addProvider = formData!;
    props.createProviderDispatch({
      body: {
        name: name,
        code: code,
      },
      pagination: filtersValues,
      callback,
    });
  };

  const handleCreateProvider = (body: addProvider) => {
    setFormData(body);
    setCheckAddProvider(true);
  };

  return isMob ? (
    <AddMobile {...props} />
  ) : (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
          </div>
        </Paper>
      </Grid> */}
            <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
              {'ایجاد تامین‌کننده'}
            </Typography>
      <Grid container xs={12} lg={12} spacing={4} alignItems="flex-start">
        <Grid container item xs={12} lg={12} alignItems="flex-end">
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Grid>
                  <Typography className={classes.typographyCards}>
                    اطلاعات تامین‌کننده
                  </Typography>
                </Grid>
              }
            />

            <CardContent className={classes.cardContentOrder}>
              <Grid container lg={12} md={12} className={classes.cardContent}>
                <Grid container item spacing={2} lg={12} md={12}>
                  <Grid container item xs={3} md={3} lg={3} alignItems="center">
                    <div className={classes.item}>
                      <div style={{width: '100%'}}>
                        <TextField
                          variant="outlined"
                          type="text"
                          fullWidth
                          id="name"
                          name="name"
                          label="نام تامین کننده"
                          inputRef={register({
                            required: true,
                          })}
                          error={errors.name && true}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid container item xs={3} md={3} lg={3} alignItems="center">
                    <div className={classes.item}>
                      <div style={{width: '100%'}}>
                        <TextField
                          variant="outlined"
                          type="text"
                          fullWidth
                          id="code"
                          name="code"
                          placeholder="برای مثال provider-1"
                          label="کد تامین کننده"
                          inputRef={register({
                            required: true,
                            pattern: {
                              value: /^[A-Za-z\d\-_]+$/,
                              message: 'مقدار وارد شده صحیح نمیباشد',
                            },
                          })}
                          error={errors.code && true}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid
        container
        lg={12}
        md={12}
        xs={12}
        spacing={2}
        style={{
          flexDirection: 'row-reverse',
          position: 'fixed',
          backgroundColor: '#D5DADD',
          bottom: '0',
          right: '75px',
          padding: '15px',
          zIndex: 2,
        }}
      >
        <Grid
          container
          style={{
            marginLeft: '35px',
            marginTop: '-4px',
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={() => window.history.back()}
            style={{
              marginRight: 'auto',
            }}
          >
            {'انصراف'}
          </Button>
          <Button
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                .length === 0
            }
            type="submit"
            size="medium"
            data-cy="search"
            autoFocus
            variant="contained"
            color="primary"
            style={{
              marginRight: '14px',
              marginLeft: '120px',
            }}
          >
            {'ذخیره تامین‌کننده'}
          </Button>
        </Grid>
      </Grid>

      <Dialog
        open={checkAddProvider}
        onClose={handleCloseCheck}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseCheck ? (
              <IconButton aria-label="close" onClick={handleCloseCheck}>
                <RonadIcons name="times" size={0.8}/>
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`آیا از ایجاد کردن تامین کننده ${formData?.name} اطیمنان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={2} style={{padding: '5px 0'}}>
              <Divider
                style={{width: '100%', marginLeft: '0', marginRight: '0'}}
              />
              <Button
                style={{margin: '7px', padding: '5px 30px'}}
                autoFocus
                onClick={handleCloseCheck}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {`انصراف`}
              </Button>
              <Button
                onClick={handleSubmitAddProvider}
                variant="contained"
                size="medium"
                color="primary"
                disabled={props.loading}
              >
                {props.loading ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  'ذخیره تامین‌کننده'
                )}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </form>
  );
}

const mapStateToProps = () =>
  createStructuredSelector<Store, State>({
    providerList: makeSelectProvidersList(),
    count: makeSelectCountList(),
    loading: makeSelectLoading(),
    error: makeSelectError(),
  });

function mapDispatchToProps(dispatch: Function) {
  return {
    providersDispatch: (payload: Payload) =>
      dispatch(getProvidersAction(payload)),

    createProviderDispatch: (payload: PayloadCreate) =>
      dispatch(createProviderAction(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Add);
